import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss'],
    standalone: false
})
export class TreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
